import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SessionService } from './session.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { IAvaluoFiscal } from 'src/app/models/contribuciones/avaluo-fiscal.model';
import { IUserInfoCognito } from './cognito.service';
import { IReporteContribuciones } from 'src/app/models/contribuciones/contribuciones.model';

type ReportType = 'AVALUO' | 'CONTRIBUCIONES';

@Injectable({
  providedIn: 'root'
})
export class ContribucionesService {
    private endpoint: string = environment.backend.contribuciones.url;
    private readonly REQUEST_ORIGIN = 'WEB';

    constructor(
        private _sessionService: SessionService,
        private http: HttpClient
    ) { }

    private getHeaders(idOrganizacion: string, idUsuario: string, requestOrigin: string): HttpHeaders {
        const headers = new HttpHeaders()
            .set("IDOrganizacion", idOrganizacion)
            .set("IDUsuario", idUsuario)
            .set("requestOrigin", requestOrigin)

        return headers
    }

    buildHttpParams(paramsObj?: Record<string, string | null | undefined>): HttpParams {
        let params = new HttpParams();

        if (!paramsObj) return params;

        for (const [key, value] of Object.entries(paramsObj)) {
            if (value != null && value !== '') {
                params = params.set(key, value);
            }
        }

        return params;
    }

    public createAvaluoFiscalReport(rut: string, claveSii = ''): Observable<IAvaluoFiscal> {

        const userInfo: IUserInfoCognito = this._sessionService.getUserInfo();
        const idUsuario = userInfo.email;
        const idOrganizacion = this._sessionService.getOrganization();

        const headers = this.getHeaders(idOrganizacion, idUsuario, this.REQUEST_ORIGIN);
        const payload = { rut, claveSii };

        return this.http.post<IAvaluoFiscal>(`${this.endpoint}avaluoFiscal`, payload, { headers });
    }

    public createContribucionesReport(rut: string, claveSii = ''): Observable<IReporteContribuciones> {

        const userInfo: IUserInfoCognito = this._sessionService.getUserInfo();
        const idUsuario = userInfo.email;
        const idOrganizacion = this._sessionService.getOrganization();

        const headers = this.getHeaders(idOrganizacion, idUsuario, this.REQUEST_ORIGIN);
        const payload = { rut, claveSii };

        return this.http.post<IReporteContribuciones>(`${this.endpoint}contribuciones`, payload, { headers });
    }

    public listReports(rut: string, reportType: ReportType) {

        const userInfo: IUserInfoCognito = this._sessionService.getUserInfo();
        const idUsuario = userInfo.email;
        const idOrganizacion = this._sessionService.getOrganization();

        const headers = this.getHeaders(idOrganizacion, idUsuario, this.REQUEST_ORIGIN);
        const params = this.buildHttpParams({ rut, reportType });

        return this.http.get(`${this.endpoint}listar`, { headers, params });
    }

    public searchTX(idTransaccion: string): Observable<any> {

        const userInfo: IUserInfoCognito = this._sessionService.getUserInfo();
        const idUsuario = userInfo.email;
        const idOrganizacion = this._sessionService.getOrganization();

        const headers = this.getHeaders(idOrganizacion, idUsuario, this.REQUEST_ORIGIN);
        const params = this.buildHttpParams({ id_transaccion: idTransaccion });

        return this.http.get<any>(`${this.endpoint}buscar`, { headers, params });
    }
}
